var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnaliseB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.38629L1.42321 6.36483L4.32916 5.95193",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.449 6.17278C19.449 6.17278 18.6745 4.72534 17.3475 3.54586C16.0204 2.36637 14.8761 1.7246 13.1444 1.33279C11.4127 0.940973 9.54637 0.839875 7.84084 1.3332C6.1353 1.82653 4.94259 2.29011 3.68747 3.54586C2.43235 4.8016 1.58594 6.17278 1.58594 6.17278",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6138L19.5895 15.6352L16.7705 16.0481",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99996 16C1.99996 16 2.75702 17.3991 4.05419 18.5392C5.35137 19.6793 6.46996 20.2996 8.16266 20.6783C9.85536 21.0571 11.6797 21.1548 13.3468 20.6779C15.014 20.2011 16.1798 19.753 17.4067 18.5392C18.6336 17.3254 19.4609 16 19.4609 16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12745 4.90943C6.51458 4 7.84306 4 10.5 4C13.1569 4 14.4854 4 14.8725 4.90943C14.9058 4.9876 14.9339 5.0688 14.9565 5.15227C15.2195 6.12331 14.2802 7.24878 12.4014 9.49972L11.1429 11L12.4014 12.5003C14.2802 14.7512 15.2195 15.8767 14.9565 16.8477C14.9339 16.9312 14.9058 17.0124 14.8725 17.0906C14.4854 18 13.1569 18 10.5 18C7.84306 18 6.51458 18 6.12745 17.0906C6.09417 17.0124 6.0661 16.9312 6.04349 16.8477C5.78051 15.8767 6.71988 14.7512 8.59863 12.5003L9.85715 11L8.59863 9.49972C6.71988 7.24878 5.78051 6.12331 6.04349 5.15227C6.0661 5.0688 6.09417 4.9876 6.12745 4.90943Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaliseB);
export default __webpack_public_path__ + "static/media/analiseB.748757c4275a8a3753284fb31db35095.svg";
export { ForwardRef as ReactComponent };